import React, { useContext } from 'react';
import {
  Box, Typography
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import NavBar from './components/NavBar';
import FilterBar from './components/FilterBar';
import CurrentSolutions from './components/data_visualizations/CurrentSolutions';
import ChosenSolutionsHeader from './components/chosen/ChosenSolutionsHeader';
import ChosenSolutionsCompare from './components/chosen/ChosenSolutionsCompare';
import JobsTable from './components/detail/tables/JobsTable';
import theme from './theme';
import { useGlobalLoading } from './context/GlobalLoadingContext';
import { DataAndFilterContext } from './context/DataAndFilterContext';



function ChosenSolutionsPage() {
  const { loading } = useGlobalLoading();
  const { filteredData } = useContext(DataAndFilterContext);


  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <Box sx={{ padding: 3 }}>
        <Typography variant="h4" gutterBottom>
          Buying Behaviors
        </Typography>
        <FilterBar />
        {/* 
        <ChosenSolutionsHeader files={filteredData} />
        <ChosenSolutionsCompare files={filteredData} height={360} />
        */}
        <Box my={4}>
          <CurrentSolutions />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default ChosenSolutionsPage;
